// 数字格式化工具函数

/**
 * 格式化大数字显示
 * @param value 数值
 * @param decimals 小数位数
 * @returns 格式化后的字符串
 */
export const formatLargeNumber = (value: number | string, decimals: number = 2): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (num >= 1e9) {
    return (num / 1e9).toFixed(decimals) + 'B';
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(decimals) + 'M';
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(decimals) + 'K';
  } else {
    return num.toFixed(decimals);
  }
};

/**
 * 格式化DOR数量显示
 * @param value DOR数量
 * @returns 格式化后的字符串
 */
export const formatDOR = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (num >= 1e9) {
    return (num / 1e9).toFixed(2) + 'B DOR';
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(2) + 'M DOR';
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(2) + 'K DOR';
  } else {
    return num.toFixed(2) + ' DOR';
  }
};

/**
 * 格式化美元金额显示
 * @param value 美元金额
 * @returns 格式化后的字符串
 */
export const formatUSD = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (num >= 1e9) {
    return '$' + (num / 1e9).toFixed(2) + 'B';
  } else if (num >= 1e6) {
    return '$' + (num / 1e6).toFixed(2) + 'M';
  } else if (num >= 1e3) {
    return '$' + (num / 1e3).toFixed(2) + 'K';
  } else {
    return '$' + num.toFixed(2);
  }
};

/**
 * 格式化百分比
 * @param value 百分比值 (0-1)
 * @param decimals 小数位数
 * @returns 格式化后的字符串
 */
export const formatPercentage = (value: number, decimals: number = 1): string => {
  return (value * 100).toFixed(decimals) + '%';
};

/**
 * 格式化地址显示
 * @param address 钱包地址
 * @param start 开头显示位数
 * @param end 结尾显示位数
 * @returns 格式化后的地址
 */
export const formatAddress = (address: string, start: number = 6, end: number = 4): string => {
  if (!address) return '';
  return `${address.slice(0, start)}...${address.slice(-end)}`;
};

/**
 * 格式化数字为千分位显示
 * @param value 数值
 * @returns 格式化后的字符串
 */
export const formatNumberWithCommas = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return num.toLocaleString();
};

/**
 * 格式化日期显示
 * @param dateString 日期字符串
 * @returns 格式化后的日期字符串
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}; 